import i18next from "i18next";
import { IQuantity } from "../../../../../common/models/quantity.model";
import { Quantity } from "../../../../../common/models/quantity.model";

export const generateFilesCommands = (
  quantity: IQuantity,
  actions: any
) => {
  const t = i18next.getFixedT(null, "admin");
  if (quantity === Quantity.NONE) {
    return [
      {
        key: "add",
        text: t("nav.add"),
        iconProps: { iconName: "add" },
        name: "add",
        onClick: actions.toggle,
      },
    ];
  } else {
    return [
      {
            key: "delete",
            text: t("nav.delete"),
            iconProps: { iconName: "delete" },
            name: "delete",
            onClick: actions.deleteFileById,
        },
        {
            key: "download",
            text: t("nav.download"),
            iconProps: { iconName: "download" },
            name: "download",
            onClick: actions.downloadFileById,
        },
    ];
  }
};
